import sideMenuActionTypes from "./side-menu.types";

const INITIAL_STATE = {
  sideNavToggle: false,
  sideNavMenu: null,
};

const sideMenuReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case sideMenuActionTypes.TOGGLE_SIDENAV:
      return {
        ...state,
        sideNavToggle: !state.sideNavToggle,
      };
    case sideMenuActionTypes.SET_SIDE_NAVIGATION_MENU:
      return {
        ...state,
        sideNavMenu: action.payload,
      };
    case sideMenuActionTypes.SIGNOUT_SUCCESS:
      return {
        sideNavToggle: false,
        sideNavMenu: null,
      };
    default:
      return state;
  }
};

export default sideMenuReducer;
